import React from 'react';
import ReactDOM from 'react-dom';
import { MapPopup as PopupBody } from './map-viewer/map-popup';

export function generatePopupHtml(
  map,
  propertyData,
  coordinates,
  popup,
  platformIcons
) {
  const coords = coordinates || propertyData.lnglat;
  const mapboxPopup =
    popup || new window.mapboxgl.Popup({ closeButton: true, offset: 10 });

  // Create a temporary div to render into
  const container = document.createElement('div');

  ReactDOM.render(
    <PopupBody
      data-cy="pop-up"
      propertyData={propertyData}
      platformIcons={platformIcons}
    />,
    container
  );

  return mapboxPopup.setLngLat(coords).setDOMContent(container).addTo(map);
}
